export default __webpack_public_path__ + "static/media/special-mention.68029bde.svg";